import { GroupProps } from '@mantine/core';
import { ThemeIcon } from '@zorro/design-system/v2/ThemeIcon';
import { Title } from '@zorro/design-system/v2/Title';
import { Group, Icon, Stack, Text } from '@zorro/web/design-system';
import { ElementType } from 'react';

type Props = {
  icon: ElementType;
  title: string;
  subtitle?: string;
  groupProps?: GroupProps;
};

export const HeaderWithIcon = ({
  icon,
  title,
  subtitle,
  groupProps,
}: Props) => {
  return (
    <Group wrap="nowrap" gap="xs" mih={42} {...groupProps}>
      <ThemeIcon size="40" color="indigo">
        <Icon icon={icon} />
      </ThemeIcon>

      <Stack gap={0}>
        <Title order={4}>{title}</Title>
        <Text size="sm" c="zorroGray.4">
          {subtitle}
        </Text>
      </Stack>
    </Group>
  );
};
